import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { RuleHistoryDateCell } from "../cells/RuleHistoryDateCell";
import { RuleHistorySummaryCell } from "../cells/RuleHistorySummaryCell";
import {
    RULE_GROUP_TYPE_LABELS,
    RuleGroupType,
    RuleHistoryListColumn,
    RuleHistoryListRow,
} from "./ruleHistoryListViewConfig";

export const transferRuleHistoryListViewConfig: ViewConfig<
    RuleHistoryListRow,
    RuleHistoryListColumn,
    never
> = {
    columns: {
        [RuleHistoryListColumn.TIME]: {
            accessorKey: "date",
            name: "Time",
            header: "",
            cell: RuleHistoryDateCell,
            immutable: true,
            ...DATE_COLUMN_SIZE,
        },
        [RuleHistoryListColumn.RULE_TYPE]: {
            accessorKey: "ruleType",
            name: "Rule type",
            header: "Rule type",
            cell: ({ getValue }) => {
                const type = getValue() as RuleGroupType;
                return RULE_GROUP_TYPE_LABELS[type] ?? type;
            },
            minSize: 100,
            maxSize: 140,
        },
        [RuleHistoryListColumn.RULE_GROUP]: {
            accessorKey: "ruleGroupName",
            name: "Rule group",
            header: "Rule group",
            minSize: 200,
            maxSize: 220,
        },
        [RuleHistoryListColumn.RULE_SUMMARY]: {
            accessorKey: "ruleResourceId",
            name: "Rule",
            header: "Rule",
            cell: RuleHistorySummaryCell,
            minSize: 200,
            maxSize: 900,
        },
    },
};
